/**
 * Permission constants — mirrors backend permission_registry.py.
 *
 * Convention: scope.resource.action
 *
 * When adding new permissions:
 *  1. Add the constant here.
 *  2. Add the matching constant in backend permission_registry.py.
 *  3. Map it to the appropriate roles in ROLE_PERMISSIONS.
 */

export const Permissions = {
  // ── Platform scope ──
  PLATFORM_SETTINGS_VIEW: 'platform.settings.view',
  PLATFORM_SETTINGS_MANAGE: 'platform.settings.manage',
  PLATFORM_TENANTS_VIEW: 'platform.tenants.view',
  PLATFORM_TENANTS_MANAGE: 'platform.tenants.manage',

  // ── Organization scope ──
  ORG_SETTINGS_VIEW: 'org.settings.view',
  ORG_SETTINGS_MANAGE: 'org.settings.manage',
  ORG_MEMBERS_VIEW: 'org.members.view',
  ORG_MEMBERS_MANAGE: 'org.members.manage',
  ORG_DEPARTMENTS_VIEW: 'org.departments.view',
  ORG_DEPARTMENTS_MANAGE: 'org.departments.manage',
  ORG_STRUCTURE_VIEW: 'org.structure.view',
  ORG_STRUCTURE_MANAGE: 'org.structure.manage',
  ORG_MODULES_MANAGE: 'org.modules.manage',

  // ── Module access scope ──
  MODULE_FINANCIAL_FORENSICS: 'module.financial_forensics.access',
  MODULE_PERFORMANCE: 'module.performance.access',

  // ── KPI / Performance scope ──
  ORG_KPI_VIEW_ALL: 'org.kpi.view_all',

  // ── Discovery (universal tool, not a gated module) ──
  MODULE_DISCOVERY_ACCESS: 'module.discovery.access',
  MODULE_DISCOVERY_MANAGE: 'module.discovery.manage',

  // ── Sales scope ──
  SALES_ACCESS: 'sales.module.access',
  SALES_LEADS_VIEW: 'sales.leads.view',
  SALES_LEADS_MANAGE: 'sales.leads.manage',
  SALES_SETTINGS_MANAGE: 'sales.settings.manage',
  SALES_AGENT_USE: 'sales.agent.use',

  // ── AML compliance scope ──
  AML_ACCESS: 'aml.module.access',
  AML_CUSTOMERS_VIEW: 'aml.customers.view',
  AML_CUSTOMERS_MANAGE: 'aml.customers.manage',
  AML_TRANSACTIONS_VIEW: 'aml.transactions.view',
  AML_TRANSACTIONS_MANAGE: 'aml.transactions.manage',
  AML_REPORTS_VIEW: 'aml.reports.view',
  AML_CLIENTS_MANAGE: 'aml.clients.manage',
  AML_SANCTIONS_VIEW: 'aml.sanctions.view',
  AML_SANCTIONS_MANAGE: 'aml.sanctions.manage',
} as const;

export type Permission = (typeof Permissions)[keyof typeof Permissions];
